"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The Icon component provides a convenient way to embed a SVG icon.
 * It uses a SVG sprite, generated on build from the icons placed into the <code>/src/assets/icons</code> folder of the library.
 */
var Icon = function Icon(_ref) {
  var name = _ref.name,
      label = _ref.label,
      color = _ref.color,
      className = _ref.className,
      labelAria = _ref.labelAria;
  var classes = (0, _clsx.default)('uk-svg', color !== 'default' && "uk-color--" + color, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": "true",
    "aria-labelledby": "icon-title"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#" + name
  }), /*#__PURE__*/_react.default.createElement("title", {
    id: "icon-title"
  }, !label ? labelAria : label)), label && /*#__PURE__*/_react.default.createElement("span", null, label), !label && /*#__PURE__*/_react.default.createElement("span", {
    className: "show-for-sr"
  }, labelAria));
};

Icon.propTypes = {
  /**
   * Name of the Icon
   * (filename of the SVG without its extension)
   */
  name: _propTypes.default.string.isRequired,

  /**
   * Label of the Icon.
   */
  label: _propTypes.default.string,

  /**
   * Color of the Icon
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'black', 'white']),

  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string
};
Icon.defaultProps = {
  color: 'default'
};
var _default = Icon;
exports.default = _default;